declare var angular: any;
import * as _ from 'underscore';
import { environment } from '../../../../environments/environment';
import { initialEnvironment } from '../../../../environments/initial-environment';
declare var moment: any;
import 'moment/locale/fr';

import { flatten } from 'lodash';
import { examData } from '../../examData';
import { getSectionsByLevel } from '../../../../app/delf/estimate';

var score = {
  toeic: {
    0: { listening: 5, reading: 5 },
    1: { listening: 5, reading: 5 },
    2: { listening: 5, reading: 5 },
    3: { listening: 5, reading: 5 },
    4: { listening: 5, reading: 5 },
    5: { listening: 5, reading: 5 },
    6: { listening: 5, reading: 5 },
    7: { listening: 5, reading: 5 },
    8: { listening: 5, reading: 5 },
    9: { listening: 5, reading: 5 },
    10: { listening: 5, reading: 5 },
    11: { listening: 5, reading: 5 },
    12: { listening: 5, reading: 5 },
    13: { listening: 5, reading: 5 },
    14: { listening: 5, reading: 5 },
    15: { listening: 5, reading: 5 },
    16: { listening: 5, reading: 5 },
    17: { listening: 5, reading: 5 },
    18: { listening: 10, reading: 5 },
    19: { listening: 15, reading: 5 },
    20: { listening: 20, reading: 5 },
    21: { listening: 25, reading: 5 },
    22: { listening: 30, reading: 10 },
    23: { listening: 35, reading: 15 },
    24: { listening: 40, reading: 20 },
    25: { listening: 45, reading: 25 },
    26: { listening: 50, reading: 30 },
    27: { listening: 55, reading: 35 },
    28: { listening: 60, reading: 40 },
    29: { listening: 70, reading: 45 },
    30: { listening: 80, reading: 55 },
    31: { listening: 85, reading: 60 },
    32: { listening: 90, reading: 65 },
    33: { listening: 95, reading: 70 },
    34: { listening: 100, reading: 75 },
    35: { listening: 105, reading: 80 },
    36: { listening: 115, reading: 85 },
    37: { listening: 125, reading: 90 },
    38: { listening: 135, reading: 95 },
    39: { listening: 140, reading: 105 },
    40: { listening: 150, reading: 115 },
    41: { listening: 160, reading: 120 },
    42: { listening: 170, reading: 125 },
    43: { listening: 175, reading: 130 },
    44: { listening: 180, reading: 135 },
    45: { listening: 190, reading: 140 },
    46: { listening: 200, reading: 145 },
    47: { listening: 205, reading: 155 },
    48: { listening: 215, reading: 160 },
    49: { listening: 220, reading: 170 },
    50: { listening: 225, reading: 175 },
    51: { listening: 230, reading: 185 },
    52: { listening: 235, reading: 195 },
    53: { listening: 245, reading: 205 },
    54: { listening: 255, reading: 210 },
    55: { listening: 260, reading: 215 },
    56: { listening: 265, reading: 220 },
    57: { listening: 275, reading: 230 },
    58: { listening: 285, reading: 240 },
    59: { listening: 290, reading: 245 },
    60: { listening: 295, reading: 250 },
    61: { listening: 300, reading: 255 },
    62: { listening: 310, reading: 260 },
    63: { listening: 320, reading: 270 },
    64: { listening: 325, reading: 275 },
    65: { listening: 330, reading: 280 },
    66: { listening: 335, reading: 285 },
    67: { listening: 340, reading: 290 },
    68: { listening: 345, reading: 295 },
    69: { listening: 350, reading: 295 },
    70: { listening: 355, reading: 300 },
    71: { listening: 360, reading: 310 },
    72: { listening: 365, reading: 315 },
    73: { listening: 370, reading: 320 },
    74: { listening: 375, reading: 325 },
    75: { listening: 385, reading: 330 },
    76: { listening: 395, reading: 335 },
    77: { listening: 400, reading: 340 },
    78: { listening: 405, reading: 345 },
    79: { listening: 415, reading: 355 },
    80: { listening: 420, reading: 360 },
    81: { listening: 425, reading: 370 },
    82: { listening: 430, reading: 375 },
    83: { listening: 435, reading: 385 },
    84: { listening: 440, reading: 390 },
    85: { listening: 445, reading: 395 },
    86: { listening: 455, reading: 405 },
    87: { listening: 460, reading: 415 },
    88: { listening: 465, reading: 420 },
    89: { listening: 475, reading: 425 },
    90: { listening: 480, reading: 435 },
    91: { listening: 485, reading: 440 },
    92: { listening: 490, reading: 450 },
    93: { listening: 495, reading: 455 },
    94: { listening: 495, reading: 460 },
    95: { listening: 495, reading: 470 },
    96: { listening: 495, reading: 475 },
    97: { listening: 495, reading: 485 },
    98: { listening: 495, reading: 485 },
    99: { listening: 495, reading: 490 },
    100: { listening: 495, reading: 495 }
  },
  bright: {
    0: 0.0,
    1: 0.0,
    2: 0.0,
    3: 0.0,
    4: 0.0,
    5: 0.0,
    6: 0.0,
    7: 0.0,
    8: 0.0,
    9: 0.0,
    10: 0.0,
    11: 0.1,
    12: 0.1,
    13: 0.2,
    14: 0.3,
    15: 0.3,
    16: 0.4,
    17: 0.5,
    18: 0.6,
    19: 0.6,
    20: 0.7,
    21: 0.8,
    22: 0.9,
    23: 1.0,
    24: 1.0,
    25: 1.1,
    26: 1.2,
    27: 1.3,
    28: 1.4,
    29: 1.5,
    30: 1.6,
    31: 1.7,
    32: 1.8,
    33: 1.9,
    34: 2.0,
    35: 2.1,
    36: 2.2,
    37: 2.3,
    38: 2.4,
    39: 2.5,
    40: 2.6,
    41: 2.7,
    42: 2.8,
    43: 2.9,
    44: 3.0,
    45: 3.1,
    46: 3.2,
    47: 3.4,
    48: 3.5,
    49: 3.6,
    50: 3.7,
    51: 3.8,
    52: 4.0,
    53: 4.1,
    54: 4.2,
    55: 4.3,
    56: 4.5,
    57: 4.6,
    58: 4.7,
    59: 4.9,
    60: 5.0
  },
  linguaskill: {
    /*
    ex:  12   part:  1 nbQuestions:  8
    ex:  12   part:  2 nbQuestions:  24
    ex:  12   part:  3 nbQuestions:  4
    ex:  12   part:  4 nbQuestions:  4
    ex:  12   part:  5 nbQuestions:  20
    ex:  12   part:  6 nbQuestions:  20
    ex:  12   part:  7 nbQuestions:  24
    Total: 104 questions
    */
    ...new Array(105).fill(0).map((val, index) => {
      return (100 / 104) * index + 82;
    })
  },
  lerobert: {
    ...new Array(105).fill(0).map((val, index) => {
      return (100 / 104) * index + 82;
    })
  },
  delf: {
    ...new Array(100).fill(0).map((val, index) => {
      return (100 / 100) * index;
    })
  }
};

var toCercl = {
  linguaskill: [
    {
      value: 99,
      level: 'Pre A1'
    },
    {
      value: 119,
      level: 'A1'
    },
    {
      value: 139,
      level: 'A2'
    },
    {
      value: 159,
      level: 'B1'
    },
    {
      value: 179,
      level: 'B2'
    },
    {
      value: 200,
      level: 'C1 or above'
    }
  ],
  bright: [
    {
      value: 0.29,
      level: null
    },
    {
      value: 0.79,
      level: 'A1'
    },
    {
      value: 1.29,
      level: 'A1+'
    },
    {
      value: 1.79,
      level: 'A2'
    },
    {
      value: 2.29,
      level: 'A2+'
    },
    {
      value: 2.79,
      level: 'B1'
    },
    {
      value: 3.29,
      level: 'B1+'
    },
    {
      value: 3.79,
      level: 'B2'
    },
    {
      value: 4.29,
      level: 'C1'
    },
    {
      value: 4.79,
      level: 'C1+'
    },
    {
      value: 5,
      level: 'C1+/C2'
    }
  ],
  toeic: [
    {
      value: 10,
      level: null
    },
    {
      value: 120,
      level: null
    },
    {
      value: 225,
      level: 'A1'
    },
    {
      value: 550,
      level: 'A2'
    },
    {
      value: 785,
      level: 'B1'
    },
    {
      value: 945,
      level: 'B2'
    },
    {
      value: 1000,
      level: 'C1'
    }
  ],
  delf: [
    {
      value: 10,
      level: null
    },
    {
      value: 120,
      level: null
    },
    {
      value: 225,
      level: 'A1'
    },
    {
      value: 550,
      level: 'A2'
    },
    {
      value: 785,
      level: 'B1'
    },
    {
      value: 945,
      level: 'B2'
    },
    {
      value: 1000,
      level: 'C1'
    }
  ]
};

var toPercent = {
  bright: 60,
  toeic: 100,
  linguaskill: 104,
  lerobert: 1000,
  delf: 100
};

angular
  .module('GlobalControllers')

  .service('exam', [
    '$http',
    'localData',
    '$mdDialog',
    'EXAM',
    function($http, localData, $mdDialog, EXAM) {
      this.examData = {
        ...examData[EXAM],
        ...initialEnvironment.data,
        ...environment.data
      };

      this.sections = [];

      if (this.examData.langForExercises !== 'en') {
        moment.updateLocale(this.examData.langForExercises);
      }

      var self = this;

      this.setLevel = function(level) {
        console.log('setLevel', level);
        self.sections = getSectionsByLevel(self.examData.part.sections, level);
      };

      /* Score */
      this.getMin = function() {
        return self.examData.score.min;
      };
      this.getMax = function() {
        return self.examData.score.max;
      };
      this.getStep = function() {
        return self.examData.score.step;
      };

      /* part */
      this.getPartById = function(partId) {
        var parts = _.flatten(
          _.map(self.sections, function(section: any) {
            return section.parts;
          })
        );
        console.log('parts', parts);
        var goodPart = _.find(parts, function(part) {
          return part.id == partId;
        });
        console.log('gd', partId);
        return goodPart;
      };
      this.partGetTitle = function(part) {
        console.log('title');
        return self.getPartById(part).title;
      };
      this.partGetHelp = function(part) {
        console.log('help');
        return self.getPartById(part).help;
      };
      this.getSectionById = function(LR) {
        return _.find(self.sections, function(section: any) {
          return section.id === LR;
        });
      };

      this.getAllPartsId = function() {
        return flatten(self.sections.map(s => s.parts.map(p => p.id)));
      };

      this.partIs = function(sectionId, part) {
        return _.contains(
          self.getSectionById(sectionId).parts.map(function(part) {
            return part.id;
          }),
          part
        );
      };

      this.getEstimationScoreToCecrl = function(score) {
        var estimationScore = _.find(toCercl[EXAM], function(grid: any) {
          return score <= grid.value;
        });

        if (!estimationScore) {
          return null;
        }
        return estimationScore.level;
      };

      this.getTheMinPercentForObjective = function(objective) {
        if (EXAM === 'bright') {
          for (var i = 0; i < 61; i++) {
            if (score[EXAM][i] >= objective) {
              return i;
            }
          }
        } else if (EXAM === 'toeic') {
          for (var i = 0; i < 101; i++) {
            if (
              score[EXAM][i].listening + score[EXAM][i].reading >=
              objective
            ) {
              return i;
            }
          }
        } else if (EXAM === 'linguaskill') {
          for (var i = 0; i < 200; i++) {
            if (score[EXAM][i] >= objective) {
              return i;
            }
          }
        } else if (EXAM === 'lerobert') {
          return objective;
          /*
        for (var i = 0; i < 1001; i++) {
          if (score[EXAM][i] >= objective) {
            return i;
          }
        }
        */
        } else if (EXAM === 'delf') {
          return objective;
          /*
        for (var i = 0; i < 1001; i++) {
          if (score[EXAM][i] >= objective) {
            return i;
          }
        }
        */
        }
      };

      this.estimatePercentScoreToGrid = function(percent, part) {
        console.log('percent', percent, 'part', part);
        percent = Math.ceil(percent * toPercent[EXAM]);
        console.log('percent', percent);
        if (EXAM === 'lerobert') {
          return percent;
        }
        if (!part) {
          if (_.keys(score[EXAM][percent]).length) {
            return sum(
              _.keys(score[EXAM][percent]).map(function(part) {
                return score[EXAM][percent][part];
              })
            );
          } else {
            return score[EXAM][percent];
          }
        } else {
          return score[EXAM][percent][part];
        }
      };

      function sum(arr) {
        return _.reduce<any, number>(
          arr,
          function(memo, num) {
            return memo + num;
          },
          0
        );
      }
    }
  ]);
